import DocPlayer from './src/main';

/* istanbul ignore next */
DocPlayer.install = function(Vue) {
  Vue.component(DocPlayer.name, DocPlayer);
};

export default DocPlayer;
